module.exports = __webpack_public_path__ + "static/media/ginger_icon1.ae856ccf.png";